export default "__VITE_ASSET__kCL35AVr__"